module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"groupBy":"Group by","allCompanies":"All companies","noGroup":"No Group"},"de":{"groupBy":"Gruppieren nach","allCompanies":"Alle Unternehmen","noGroup":"Keine Gruppe"}}')
  delete Component.options._Ctor
}
